export const STEPS_BLOCK_STYLE = {
    description: 'text-white/80 text-l font-light group-data-primary:text-secondary-text group-data-gray:text-secondary-text',
    iconText: 'text-white group-data-primary:text-secondary-text group-data-gray:text-secondary-text',
    iconBackground: 'bg-white/30 group-data-primary:bg-main-divider',
    iconConnector: 'bg-white group-data-primary:bg-secondary-light',
    dot: 'bg-white/80 group-data-primary:bg-secondary-text',
};
//# sourceMappingURL=StepsBlockStyleMaps.js.map